import { render } from "./CompanyStep2Form.vue?vue&type=template&id=5e212de6&scoped=true"
import script from "./CompanyStep2Form.vue?vue&type=script&lang=js"
export * from "./CompanyStep2Form.vue?vue&type=script&lang=js"

import "./CompanyStep2Form.vue?vue&type=style&index=0&id=5e212de6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e212de6"]])

export default __exports__